"use client";

import { ListTickIcon } from "@/components/icons/SiteMarks";

/** Shared side-rail tick list (services sub-services, contact focus, etc.). */
export function SideTickList({
  title,
  items,
}: {
  title: string;
  items: readonly string[];
}) {
  return (
    <div className="product_list f f-c">
      <span className="uppercase _ele">{title}</span>
      <ul className="f f-c">
        {items.map((item) => (
          <li className="f a-s _ele" key={item}>
            <ListTickIcon />
            {/* dir=auto keeps Latin tokens (e.g. DevOps) from flipping tick order. */}
            <span className="small label light_60" dir="auto">
              {item}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
